import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { NgxSpinnerService } from "ngx-spinner";
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-novo-unidade-medida',
  templateUrl: './novo-unidade-medida.component.html',
  styleUrls: ['./novo-unidade-medida.component.scss', '../../styles/estilo.padrao.scss']
})
export class NovoUnidadeMedidaComponent implements OnInit {
  uid;
  unidadeForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
  ) {
    this.uid = localStorage.getItem('uid')
  }

  ngOnInit(): void {
    this.unidadeForm = this.formBuilder.group({
      nomeUnidade: ['', [Validators.required]],
    });
  }

  cadastrar() {

    this.spinner.show('default');

    if (this.unidadeForm.valid) {
      this.usuarioService.getUnidadeMedidaDuplicada(this.uid, this.f.nomeUnidade.value.trim()).pipe(take(1)).subscribe(async snap => {
        if (snap.length === 0) {
          try {
            const resp = await this.usuarioService.setUnidadeMedida(this.uid, this.f.nomeUnidade.value.trim());
            setTimeout(() => {
              this.spinner.hide('default');
              if (resp) {

                this.usuarioService.setLog("Cadastro de unidade de medida: " + this.f.nomeUnidade.value.trim(), false, this.uid);

                this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                  this.router.navigate(["/pages/consultar-unidade-medida"], { queryParams: { IDUnidade: resp } }));
              } else {
                this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                  this.router.navigate(["/pages/novo-unidade-medida"]));
              }
            }, 2000);
          } catch (e) {
            console.log(e)
            this.spinner.hide('default');

            this.usuarioService.setLog("Erro no cadastro da unidade de medida: " + this.f.nomeUnidade.value.trim() + ' Erro: ' + e, null, this.uid);

            this.toastr.error('Erro ao cadastrar unidade!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
            this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
              this.router.navigate(["/pages/novo-unidade-medida"]));
          }
        } else {
          this.toastr.error('Já existe uma unidade com este nome!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
          setTimeout(() => this.spinner.hide('default'), 500);
        }
      });

    } else {
      this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      this.unidadeForm.markAllAsTouched();
      setTimeout(() => this.spinner.hide('default'), 500);
    }

  }

  limparCampos() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/novo-unidade-medida"]));
  }

  // convenience getter for easy access to form fields
  get f() { return this.unidadeForm.controls; }

}